// src/tabs.anatomy.ts
import { createAnatomy } from "@zag-js/anatomy";
var anatomy = createAnatomy("tabs").parts("root", "tablist", "trigger", "contentGroup", "content", "indicator");
var parts = anatomy.build();

export {
  anatomy,
  parts
};
